import axiosInstance from ".";

export const getResidential = () => {
  return axiosInstance.get("/residential");
};

export const updateResidential = (data) => {
  return axiosInstance.post("/residential", data);
};
